define('SuiteCommerce.OrderStatus.Shopping',
  [
    'SuiteCommerce.OrderStatus.OrderFinder.Router',
    'SuiteCommerce.OrderStatus.Utils',
    'SuiteCommerce.OrderStatus.Instrumentation.InstrumentationHelper',
    'SuiteCommerce.OrderStatus.Configuration'
  ],
  function define(
    Router,
    Utils,
    InstrumentationHelper,
    Configuration
  ) {
    'use strict';
    return {
      mountToApp: function mountToApp(container) {
        var log = InstrumentationHelper.initialize(container);
        Configuration.initialize(container);
        // eslint-disable-next-line no-new
        new Router(container);
        Utils.registerHandlevarsHelpers();
      }
    };
  });
